import React, { FC, useContext } from "react";
import { observer } from 'mobx-react-lite';
import { LeftPaneContext } from "../../LeftPaneContext";
import { TreeNode, TreeNodeLabel } from '../TreeNode';
import { InstructionNodeProps } from './InstructionNodeFactory';
import { SetVariableInstruction, Axis, Input } from '../../../../../machinelogic/types';

interface SetVariableInstructionProps extends InstructionNodeProps {
  instruction: SetVariableInstruction;
}
type GetAxisByUuid = (uuid: string) => Axis | undefined;
type GetInputByUuid = (uuid: string) => Input | undefined;

interface GetInstructionLabelProps {
    instruction: SetVariableInstruction
    getInputByUuid: GetInputByUuid
    getAxisByUuid: GetAxisByUuid
}

const getInstructionLabelName = ({instruction, getInputByUuid, getAxisByUuid}: GetInstructionLabelProps): string => {
  switch(instruction.name) {
    case 'fromActuatorPosition': {
      const axis = getAxisByUuid(instruction.parameters.axis);
      const axisName = axis?.name || "UNKNOWN Axis";
      return `Set ${instruction.parameters.variableName} from ${axisName}`;
    }
    case 'fromDevice': {
      const input = getInputByUuid(instruction.parameters.inputUuid);
      const inputName = input?.name || "UNKNOWN Input";
      return `Set ${instruction.parameters.variableName} from ${inputName}`;
    }
    case 'fromExpression':
      return `Set ${instruction.parameters.variableName} to ${instruction.parameters.expression}`;
    case 'fromExpressionArray':
      return `Set Variables from Expression Array`;
  }
};

export const SetVariableNode: FC<SetVariableInstructionProps> = observer(({instruction, titleClassName = '', isSelected, isInvalid, onClick}) => {

  const { library } = useContext(LeftPaneContext);
  const getInputByUuid = (uuid) => library.getConfigManager().getInputByUuid(uuid);
  const getAxisByUuid = (uuid) => library.getConfigManager().getAxisByUuid(uuid);

  const instructionLabel = <TreeNodeLabel
    icon="icon-variable"
    name={getInstructionLabelName({instruction, getInputByUuid, getAxisByUuid})}
    isSelected={isSelected}
    isInvalid={isInvalid}
    onClick={onClick}
  />;

  return (
    <TreeNode title={instructionLabel} titleClassName={titleClassName} />
  );
});
